export default {
  regionalRiskAssessment: {
    eudrDueDiligence: "Due Diligence EUDR",
    title: "Valutazione del Rischio Regionale",
    titleTT: "Benchmarking dei paesi nella valutazione del rischio regionale EUDR",
    details: "Dettagli",
    detailsTT: "Espandi per visualizzare criteri dettagliati e riferimenti relativi alla classificazione ad alto rischio, concentrandosi su deforestazione, diritti indigeni, corruzione e questioni di diritti umani.",
    createNewCountryReport: "Crea Nuovo Rapporto Paese",
    updateCountryReport: "Aggiorna Rapporto Paese",
    duplicateCountryReport: "Duplica Rapporto Paese",
    search: "Cerca",
    country: "Paese",
    dateCreated: "Data di Creazione",
    edit: "Modifica",
    delete: "Elimina",
    duplicate: "Duplica",
    actions: "Azioni",
    submit: "Invia",
    save: "Salva",
    cancel: "Annulla",
    selectCountry: "Seleziona Paese",
    riskAssessmentCriteria: "Criteri di Valutazione del Rischio",
    riskLevel: "Livello di Rischio",
    unassigned: "Non Assegnato",
    standard: "Standard",
    standardToHigh: "Da Standard ad Alto",
    high: "Alto",
    reportDetails: "Dettagli del Rapporto",
    select: "Seleziona",
    requiredFields: "Questo campo è obbligatorio",
    pleaseFillRequiredFields: "Si prega di compilare tutti i campi obbligatori",
    createCuccess: "Valutazione del rischio regionale creata con successo",
    updateSuccess: "Valutazione del rischio regionale aggiornata con successo",
    createError: "Errore nella creazione della valutazione del rischio regionale",
    updateError: "Errore nell'aggiornamento della valutazione del rischio regionale",
    deleteSuccess: "Valutazione del rischio regionale eliminata con successo",
    duplicateSuccess: "Valutazione del rischio regionale duplicata con successo",
    deleteRegionalRisk: "Elimina Valutazione del Rischio Regionale",
    confirmDelete: "Sei sicuro di voler eliminare questa valutazione del rischio regionale?",
    confirm: "Conferma",
    saveSuccess: "Valutazione del rischio regionale salvata con successo",
    fetchError: "Errore nel recupero della valutazione del rischio regionale",
    disregard: "Ignora Segmenti",
    addRegionalRiskAssessment: "Aggiungi Valutazione del Rischio Regionale",
    summary: "Sommario",
    summaryTT: "Questa sezione delinea i livelli di rischio assegnati in base a dati e riferimenti completi.",
    summaryText: "La valutazione del rischio del paese classificherà il paese della fattoria secondo i seguenti livelli di rischio (Alto, Standard e Zero/Négligibile) basati su riferimenti verificabili, informazioni, documenti e dati. I risultati diversi da 'Zero/Négligibile' indicheranno la necessità di un'azione di mitigazione del rischio (AMR) per garantire un 'Rischio Zero/Négligibile'. La Tabella 1 mostra i risultati complessivi della valutazione del rischio per la (country). La valutazione completa del rischio del paese è allegata a questo documento nell'Allegato III.",
    disregardConfirmTitle: "Ignora Qualsiasi Segmento o Tutti",
    selectSegment: "Seleziona i segmenti da ignorare.",
    addConfirmTitle: "Aggiungi Qualsiasi Segmento o Tutti",
    deselectToAddSegment: "Deseleziona i segmenti da aggiungere.",
    all: "Tutti",
    protectedAreas: "Aree Protette e Indigene",
    verificaton: "Verifica con il Database del Governo del Brasile",
    confirmation: "Conferma",
    confirmationMessage: "Sei sicuro di voler ignorare la valutazione del rischio regionale? Confermando questa azione si rimuoverà la valutazione del rischio regionale dal rapporto di due diligence.",
    noSegmentSelectedMessage: "Nessun segmento selezionato. Si prega di selezionare un segmento per procedere.",
    singleRiskAssessmentCriteriaMessage: "Sei sicuro di voler aggiungere o rimuovere i Criteri di Valutazione del Rischio Regionale? Confermando questa azione, il rapporto di due diligence verrà aggiornato.",
    singleProtectedAreasMessage: "Sei sicuro di voler aggiungere o rimuovere le Aree Protette e Indigene? Confermando questa azione, il rapporto di due diligence verrà aggiornato.",
    bothSegmentsMessage: "Sei sicuro di voler aggiungere o rimuovere sia i Criteri di Valutazione del Rischio Regionale che le Aree Protette e Indigene? Confermando questa azione, il rapporto di due diligence verrà aggiornato.",
    segmentsUpdatedSuccessfully: "Segmenti aggiornati con successo"
  }
}
